const COMMON_MESSAGES = {
  MESSAGE_RELOAD_PAGE: 'Login session has expired. Please reload the page.',
  MESSAGE_PLEASE_LOGIN: 'Your session has expired. Please log in again.',
  ADD_USER_SUCCESSFUL: 'Add user successfully.',
  EDIT_PROFILE_SUCCESSFUL: 'Edit profile successfully.',
  CHANGE_PASSWORD_SUCCESSFUL: 'Change password successfully.',
  EDIT_PORTAL_SUCCESSFUL: 'Edit portal successfully.',

  // Email template
  ADD_EMAIL_TEMPLATE: 'Add email template successfully.',
  UPDATE_EMAIL_TEMPLATE: 'Update email template successfully.',
  DELETE_EMAIL_TEMPLATE: 'Delete email template successfully.',

  // User template
  UPDATE_ROLE_USER_TEMPLATE: 'The role has been successfully changed.',
  UNABLE_UPDATE_ROLE_USER: 'Unable to change role.',

  // Article
  SAVE_DRAFT_SUCCESS: 'Save as draft topic successfully!',
  SUBMIT_TOPIC_SUCCESS: 'Submit topic successfully!',
  SAVE_DRAFT_FAIL: 'Save as draft topic unsuccessfully!',
  SUBMIT_TOPIC_FAIL: 'Submit topic unsuccessfully!',
  REJECT_AUTHOR_REVIEW: 'Reject topic successfully',
  APPROVE_AUTHOR_REVIEW: 'Approve topic successfully',

  // Review
  SUBMIT_REVIEW: 'Submit review successfully!',
  SAVE_AS_DRAFT: 'Save as draft successfully!',
  APPROVE_REVIEW: 'Approve successfully!',
  SET_BACK_TO_DRAFT: 'Set back to draft successfully!',
  SUBMIT_REVIEW_FAIL: 'Submit review unsuccessfully!',
  SAVE_AS_DRAFT_FAIL: 'Save as draft unsuccessfully!',
  APPROVE_REVIEW_FAIL: 'Approve unsuccessfully!',
  SET_BACK_TO_DRAFT_FAIL: 'Set back to draft unsuccessfully!',

  // feedback user site
  SUBMIT_FEEDBACK: 'Thank you for your feedback.',
  UNABLE_FEEDBACK: 'Unable to send feedback.'
};

export default COMMON_MESSAGES;
